import { render, staticRenderFns } from "./Medicamento.vue?vue&type=template&id=1a05df02&scoped=true"
import script from "./Medicamento.vue?vue&type=script&lang=js"
export * from "./Medicamento.vue?vue&type=script&lang=js"
import style0 from "./Medicamento.vue?vue&type=style&index=0&id=1a05df02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a05df02",
  null
  
)

export default component.exports